import { ICapable } from "../../../common/interfaces/capableInterfaces";
import IRepo from "../../../common/interfaces/repo";
import Capable from "../../../common/mixins/capable";
import Decorator from "../../../common/models/decorator";
import Repo from "../../../common/state/modules/repo";
import ImageUpload from "../../organization_settings/models/imageUpload";
import { ActivationStatusType, ActivationStatusTypeDisplay } from "./activationStatusType";

export default class UserDecorator extends Capable(Decorator) implements ICapable {
  id: string = '';
  organization_ids: string[] = [];
  portal_ids: string[] = [];
  form_ids: string[] = [];
  published_form_ids: string[] = [];
  unpublished_form_ids: string[] = [];
  license_ids: string[] = [];
  published_license_ids: string[] = [];
  unpublished_license_ids: string[] = [];
  submission_ids: string[] = [];
  completer_assignment_ids: string[] = [];
  time_zone: string = 'EST';
  image_uploads: ImageUpload[] = [];
  activation_status: number = null;
  // Used to check permissions in Analyst Dashboard
  can_view_data_tables_reporting_and_submissions?: boolean
  is_admin?: boolean
  share: any;
  can_reset_expired: boolean
  expired?: boolean
  // @ts-ignore
  static repo: IRepo<UserDecorator> = new Repo<UserDecorator>('userDecorators', UserDecorator);

  static get displayName(): string {
    return 'UserDecorator';
  }

  get clientIdOrId() {
    return this.id;
  }

  get organization_count()  {
    return this.organization_ids.length;
  }
  get portal_count()  {
    return this.portal_ids.length;
  }
  get form_count()  {
    return this.form_ids.length;
  }
  get published_form_count()  {
    return this.published_form_ids.length;
  }
  get unpublished_form_count()  {
    return this.unpublished_form_ids.length;
  }
  get license_count()  {
    return this.license_ids.length;
  }
  get published_license_count()  {
    return this.published_license_ids.length;
  }
  get unpublished_license_count()  {
    return this.unpublished_license_ids.length;
  }
  get document_count()  {
    return this.form_count + this.license_count;
  }
  get published_document_count()  {
    return this.published_form_count + this.published_license_count;
  }
  get unpublished_document_count()  {
    return this.unpublished_form_count + this.unpublished_license_count;
  }
  get submission_count()  {
    return this.submission_ids.length;
  }
  get completer_assignment_count()  {
    return this.completer_assignment_ids.length;
  }

  get avatar(): ImageUpload {
    return this.image_uploads.find(img => img.name === 'avatar');
  }

  get activationStatusDisplay(): string {
    return ActivationStatusTypeDisplay[this.activation_status];
  }

  get isDeactivated(): boolean {
    return this.activation_status === ActivationStatusType.inactive
  }
}